import { useState, useEffect } from 'react';
import { fetchProject } from '../services/api';

/**
 * Hook pour charger et gérer un projet
 */
export function useProject() {
    const [project, setProject] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function load() {
            try {
                setIsLoading(true);
                setError(null);
                
                const project_id = new URLSearchParams(window.location.search).get('project_id');

                const projectData = await fetchProject(project_id);
                setProject(projectData);

            } catch (err) {
                console.error('Erreur de chargement:', err);
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        }
        
        load();
    }, []);

    // Fonction pour recharger le projet
    const reload = async () => {
        try {
            setIsLoading(true);
            setError(null);
            const projectData = await fetchProject();
            setProject(projectData);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        project,
        isLoading,
        error,
        reload,
    };
}

